module.exports = __webpack_public_path__ + "static/img/original.cb6d1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Upload/original.png
// module id = KKcd
// module chunks = 19